import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { CELL_SETS_LOADED, CELL_SETS_LOADING, CELL_SETS_ERROR } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
import downloadFromS3 from 'utils/work/downloadFromS3';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var loadCellSets = function loadCellSets(experimentId) {
  var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error, updatingClustering, initialLoadPending, loadingBlocked, requiresLoading, shouldLoad, _signedUrl, _cellSetsData, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error, updatingClustering = _getCellSets.updatingClustering, initialLoadPending = _getCellSets.initialLoadPending;
              loadingBlocked = loading || updatingClustering;
              requiresLoading = initialLoadPending || error;
              shouldLoad = requiresLoading && !loadingBlocked;
              if (!(!shouldLoad && !forceReload)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              dispatch({
                type: CELL_SETS_LOADING
              });
              _context.prev = 7;
              _context.next = 10;
              return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"));
            case 10:
              _signedUrl = _context.sent;
              _context.next = 13;
              return downloadFromS3('CellSets', _signedUrl);
            case 13:
              _cellSetsData = _context.sent;
              dispatch({
                type: CELL_SETS_LOADED,
                payload: {
                  experimentId: experimentId,
                  data: _cellSetsData.cellSets
                }
              });
              _context.next = 22;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](7);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_CELL_SETS);
              console.error(_context.t0);
              dispatch({
                type: CELL_SETS_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 17]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadCellSets;